export const TAP_TO_PAY_FEATURE_FLAG = 'pro_checkout_taptopay_ev3978_20221027';
export const STRIPE_MIN_TRANSACTION_AMOUNT = 0.5;
export const TAP_TO_PAY_TRANSACTION_ERROR_TEST_SWITCH = 'pro_checkout_taptopay_test_ev3892_20220728';
export const TAP_TO_PAY_PAYMENT_ERROR_TEST_SWITCH = 'pro_checkout_taptopay_test_ev3893_20220728';
export const TAP_TO_PAY_CARD_ERROR_TEST_SWITCH = 'pro_checkout_taptopay_test_ev3894_20220728';
export const TAP_TO_PAY_DEVICE_ELIGIBILE_TEST_SWITCH = 'pro_taptopay_optin_force_eligibility_ev3987_20221012';
export const TAP_TO_PAY_APPOINTMENT_GENERIC_ERROR_CODE = 422;
export const TAP_TO_PAY_HELP_URL = 'https://mss.styleseat.com/tap-to-pay/';
export const HAD_SUCCESSFUL_CONNECTION_USERSTATE_KEY = 'tapToPayHadSuccessfulConnection';

export enum FlowStep {
  ProHandPhoneToClient = 'Pro hands phone to client',
  ClientTipSelection = 'Client selects tip',
  CollectClientContactInfo = 'Client enters contact info',
  ClientHandPhoneToPro = 'Client hands phone to pro',
  TransactionError = 'Transaction Error',
  PaymentError = 'Payment Error',
  CardError = 'Card Error',
}
